// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"WhatsappListLayout_headerContainer__1hya-"};